export const watchPosition = (successFn, errorFn) => {
  return navigator?.geolocation?.watchPosition(successFn, errorFn);
};
